import axios from 'axios';
import { APIOverrides } from "../../ApiOverrides"
import type { LeagueProps, TeamProps, TeamRankingProps, TeamRecordProps } from '../../types';


let EVENT_SVC_API = ''
//let AUTH_SVC_API = ''
//let MK_SVC_API = ''
//let SOCIAL_SVC_API = ''

export { RankingsApi, RankingsHelpers }

const RankingsApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        //MK_SVC_API = endpoints['MK_SVC_API'] as string;
        //AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        //SOCIAL_SVC_API = endpoints['SOCIAL_SVC_API'] as string;
    },
    getLeagues: async():Promise<LeagueProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/leagues/all`);
            return resp.data.leagues
        } catch (e) {
            return []
        }
    },
    getStandingsByLeague: async(league_id:string, year:number):Promise<undefined|{ teams:TeamProps[], league:LeagueProps, team_rankings:TeamRankingProps[], team_records:TeamRecordProps[] }> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/teams/standings/league/${league_id}/${year}`);
            return resp.data
        } catch (e) {
            return undefined
        }
    },
    getTeamsByLeagueId:async(league_id:string):Promise<TeamProps[]> => {
        try {
            console.log('here')
            const resp = await axios.get(`${EVENT_SVC_API}/v1/teams/league/${league_id}`);
            console.log(resp.data)
            return resp.data.teams
        } catch (e) {
            console.log(e)
            return []
        }
    },
}



const RankingsHelpers = {
    getWinPct: (wins:number, losses:number, draws:number) => {
        const total = wins + losses + draws;
        if (total === 0) return 0; // avoid divide by zero
        return (wins + 0.5 * draws) / total;
    },
    getRankingTypeDescriptor: (ranking_type:string) => {
        switch(ranking_type){
            case 'PRE': return 'Preseason'
            case 'REG': return 'Regular Season'
            case 'PST': return 'Post Season'
            default: return ranking_type
        }
    },
    sortDivisions: (league_id:string, divisions:string[]) => {
        switch(league_id){
            case '2':
                return ['I-A', 'I-AA', 'Division II', 'Division III']
            default: return divisions.sort((a,b) => a.localeCompare(b))
        }
    },
    getDivisionLabel: (division:string) => {
        switch(division){
            case 'I-A': return 'FBS (Division I-A)'
            case 'I-AA': return 'FCS (Division I-AA)' 
            default: return division
        }
    }
}
